import React from 'react'
import AddStudenetForm from '../AdminPages/form/addStudentForm'
import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'
import { Paper } from '@mui/material'


function RegisterStudent() {
    return (
        <>
            <Navbar />
            <div className='p-md-3'>
                <Paper elevation={3} className='p-md-3'>
                    <h3>Student Registration form</h3>
                    <div className='container'>
                    <AddStudenetForm />
                    </div>
                </Paper>
            </div>
            <Footer />
        </>
    )
}

export default RegisterStudent